import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20entertainment%20news%20portal%20hero%20background%2C%20warm%20coral%20and%20deep%20amber%20gradient%20tones%2C%20stylized%20geometric%20shapes%20floating%20in%20dynamic%20composition%2C%20soft%20glowing%20particles%2C%20dark%20textured%20overlay%2C%20editorial%20magazine%20aesthetic%2C%20minimalist%20yet%20dramatic%2C%20clean%20lines%20with%20organic%20curves%2C%20no%20text%20or%20words%2C%20abstract%20artistic%20background%20with%20warm%20lighting&width=1920&height=1080&seq=hero-51chigua-2026&orientation=landscape"
          alt="51吃瓜黑料网 - 网曝门与爆料入口全收录"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight max-w-3xl">
          51吃瓜黑料网
        </h1>
        <p className="mt-3 md:mt-4 text-base md:text-xl text-background-50/80 max-w-2xl font-medium">
          网曝门与爆料入口全收录
        </p>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/60 max-w-xl leading-relaxed">
          网红猛料实时追踪不停更 · 每日大赛精彩不断 · 视频24小时不打烊
        </p>
        <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/wangbaomen"
            className="flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-bold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line"></i>
            <span>立即吃瓜</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/category/daily-contest"
            className="flex items-center gap-2 px-7 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-trophy-line"></i>
            <span>每日大赛</span>
          </Link>
        </div>
      </div>
    </section>
  );
}